import Markdown from "markdown-to-jsx";
import { useEffect, useState } from "react";

const Terms = () => {
  const file_name = "KOLDYE_TOU_Terms_of_Use_Rev_-_1-5-22.md";
  const [post, setPost] = useState("");

  useEffect(() => {
    import(`../../../markdown/${file_name}`)
      .then((res) => {
        fetch(res.default)
          .then((res) => res.text())
          .then((res) => setPost(res));
      })
      .catch((err) => console.log(err));
  });

  return (
    <div class="doc-container px-6 mx-auto flex items-center flex-col py-20">
      <h2 class=" text-2xl font-medium mb-5">Terms of Use</h2>
      <Markdown>{post}</Markdown>
    </div>
  );
};

export default Terms;
